(function () {
  const params = new URLSearchParams(window.location.search);
  const promoKeys = ['promo', 'discount', 'coupon', 'utm_campaign'];
  let found = false;
  const record = { path: window.location.pathname, timestamp: Date.now() };
  promoKeys.forEach(function (key) {
    if (params.has(key)) {
      record[key] = params.get(key);
      found = true;
    }
  });
  if (found) {
    try {
      let updated = JSON.parse(localStorage.getItem('cc_promo_memory') || '[]');
      updated.push(record);
      if (updated.length > 50) updated = updated.slice(updated.length - 50);
      localStorage.setItem('cc_promo_memory', JSON.stringify(updated));
      localStorage.setItem('cc_promo_memory_export', JSON.stringify(updated));
    } catch (_e) {}
  }
  try {
    const stored = JSON.parse(localStorage.getItem('cc_promo_memory') || '[]');
    const script = document.createElement('script');
    script.type = 'application/json';
    script.id = 'promo-memory-data';
    script.textContent = JSON.stringify(stored);
    document.documentElement.appendChild(script);
  } catch (_e) {}
})();
